import { Col } from 'reactstrap';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { translate, Storage } from 'react-jhipster';
import React, { useState, useEffect } from 'react';
import { useAppSelector } from 'app/config/store';
import { AUTHORITIES } from 'app/config/constants';

export const AmountTransferredSection = ({ responsiveFont, quotationEntity, onAmountTransferredChange }) => {
  const account = useAppSelector(state => state.authentication.account);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [isTransferred, setIsTransferred] = useState(quotationEntity?.amountTransferred || false);
  const canEditAmountTransferred = account?.authorities?.includes(AUTHORITIES.SUBADMIN_TRANSFER_CHECKER);

  const handleCheckboxChange = e => {
    if (!canEditAmountTransferred) {
      return;
    }

    const checked = e.target.checked;
    setIsTransferred(checked);

    if (onAmountTransferredChange) {
      onAmountTransferredChange(checked);
    }

    setShowSnackbar(true);
  };

  const handleCloseSnackbar = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnackbar(false);
  };

  useEffect(() => {
    setIsTransferred(quotationEntity?.amountTransferred || false);
  }, [quotationEntity?.amountTransferred]);

  return (
    <>
      <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '17px' }}>
        <div className="d-flex align-items-center justify-content-between">
          <ThemeProvider theme={responsiveFont}>
            <Typography variant="body2" component="div">
              <strong>{translate('comexApp.quotation.amountTransferred.heading')}</strong>
            </Typography>
          </ThemeProvider>

          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="amountTransferredCheck"
              checked={isTransferred}
              onChange={handleCheckboxChange}
              disabled={!canEditAmountTransferred}
              style={{ transform: 'scale(1.5)' }}
            />
            <label className="custom-control-label" htmlFor="amountTransferredCheck" style={{ paddingLeft: '25px' }} />
          </div>
        </div>

        {!canEditAmountTransferred && (
          <ThemeProvider theme={responsiveFont}>
            <Typography
              variant="caption"
              component="div"
              style={{
                color: '#666',
                marginTop: '8px',
                fontSize: '11px',
                textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left',
              }}
            >
              {translate('comexApp.quotation.amountTransferred.viewOnly')}
            </Typography>
          </ThemeProvider>
        )}
      </Col>

      {/* Snackbar */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{
            width: '300px',
            minWidth: 'auto',
            '& .MuiAlert-action': {
              paddingRight: Storage.session.get('locale') === 'ar-ly' ? '80px' : '0',
            },
          }}
        >
          {translate('comexApp.quotation.amountTransferred.updated')}:{' '}
          {isTransferred ? translate('comexApp.quotation.amountTransferred.yes') : translate('comexApp.quotation.amountTransferred.no')}
        </Alert>
      </Snackbar>
    </>
  );
};
